import React from 'react';

interface SimpleLoaderProps {
  size?: number;
  className?: string;
  message?: string;
}

const SimpleLoader: React.FC<SimpleLoaderProps> = React.memo(({ size = 24, className = '', message }) => {
  const style = {
    width: `${size}px`,
    height: `${size}px`,
    borderWidth: `${Math.max(2, Math.floor(size / 10))}px`,
  };

  const spinner = (
    <div
      style={style}
      className={`animate-spin rounded-full border-solid border-current border-r-transparent text-[#8E8E8E] motion-reduce:animate-[spin_1.5s_linear_infinite] ${className}`}
      role="status"
    >
      <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
        Loading...
      </span>
    </div>
  );

  return (
    // Shown only after 150ms, so a fast load never flashes a spinner.
    <div className="skeleton-in flex flex-col items-center justify-center gap-4 h-full">
      {spinner}
      {message && (
        <span className="text-xs text-white text-center">
          {message}
        </span>
      )}
    </div>
  );
});

SimpleLoader.displayName = 'SimpleLoader';

export default SimpleLoader;